var o = function o(e) {
  return e.replace(/{|}/g, "");
};
export { o as removeReservedSymbols };